import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M1.68 5.182c0-.444.36-.803.803-.803h14.456a.803.803 0 1 1 0 1.606H2.483a.803.803 0 0 1-.803-.803Z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M8.104 2.772a.803.803 0 0 0-.803.803v.803h4.819v-.803a.803.803 0 0 0-.804-.803H8.104Zm5.622 1.606v-.803a2.41 2.41 0 0 0-2.41-2.409H8.104a2.41 2.41 0 0 0-2.41 2.41v.802H4.089a.803.803 0 0 0-.803.804v11.243a2.41 2.41 0 0 0 2.41 2.41h8.03a2.41 2.41 0 0 0 2.41-2.41V5.182a.803.803 0 0 0-.803-.804h-1.606ZM4.89 5.985v10.44a.803.803 0 0 0 .804.803h8.03a.803.803 0 0 0 .804-.803V5.985H4.89Z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M8.104 8.395c.443 0 .803.36.803.803v4.818a.803.803 0 0 1-1.606 0V9.198c0-.444.36-.803.803-.803ZM11.319 8.395c.443 0 .803.36.803.803v4.818a.803.803 0 0 1-1.606 0V9.198c0-.444.36-.803.803-.803Z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_5]))
}
export default { render: render }